import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import {
  EstablishmentDTO,
  TpvBoleta,
  TpvBuyDTO,
  TpvDetailDTO,
  TpvQueryResponse,
  TpvRefundDTO,
  TpvResponseDTO,
  TPVTariffDTO,
} from '../model/revolving-model';

@Injectable()
export class RevolvingApi {
  constructor(private _http: HttpClient) {}

  postTpvPurchase(tpvBuyDTO: TpvBuyDTO): Observable<TpvResponseDTO> {
    return this._http.post<any>(environment.URL_BASE_REQUEST + environment.subUrlTPVPurchase, tpvBuyDTO);
  }

  getTariffs(request: EstablishmentDTO): Observable<TPVTariffDTO[]> {
    return this._http.post<any>(environment.URL_BASE_REQUEST + environment.subUrlTPVTariffs, request);
  }

  postTpvQuery(request: TpvDetailDTO): Observable<TpvQueryResponse> {
    return this._http.post<TpvQueryResponse>(environment.URL_BASE_REQUEST + environment.subUrlTPVQuery, request);
  }

  postTpvQueryPrint(request: TpvDetailDTO): Observable<any> {
    const httpOptions = { responseType: 'blob' as 'json' };
    return this._http.post<any>(environment.URL_BASE_REQUEST + environment.subUrlTPVQueryPrint, request, httpOptions);
  }

  postTpvQueryPrintBoleta(request: TpvBoleta): Observable<any> {
    const httpOptions = { responseType: 'blob' as 'json' };
    return this._http.post<any>(
      environment.URL_BASE_REQUEST + environment.subUrlTPVQueryPrintBoleta,
      request,
      httpOptions
    );
  }
  postTpvRefund(tpvRefundDTO: TpvRefundDTO): Observable<TpvResponseDTO> {
    return this._http.post<any>(environment.URL_BASE_REQUEST + environment.subUrlTPVRefunds, tpvRefundDTO);
  }

  getPurchaseDescription(tpvRefundDTO: TpvRefundDTO): Observable<string> {
    return this._http.post<any>(environment.URL_BASE_REQUEST + environment.subUrlTPVPurchaseDescription, tpvRefundDTO);
  }
}
